import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AbsDropdownComponent } from './abs-dropdown.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
	],
	declarations: [
		AbsDropdownComponent, 
	],
	exports: [AbsDropdownComponent],
	providers: [],
})
export class AbsDropdownModule { }
